module.exports = __webpack_public_path__ + "img/iphone-12-pro-max-frame.72b7508.png";